/**
 * The brand palette as plain data: the one set of values both styling systems
 * read. `themeDefault.js` builds MUI's theme from it and `tailwind.config.js`
 * turns it into the `--ms-*` tokens the shadcn components use, so the two
 * cannot drift.
 *
 * Keep this file free of imports. `tailwind.config.js` loads it in Node at
 * build time, so it cannot reach the app or MUI. To add a token, add the
 * value here and map it in `tailwind.config.js`.
 */

export const colors = {
  primary: '#0DA79D',
  secondary: '#F5684D',
  basic: '#383838',
  white: '#ffffff',
  action: {
    active: '#4EBAC5',
    disabled: '#AAAAAA',
    focus: '#22D0B8',
    focusOpacity: 0.4,
  },
  error: {
    main: '#ff4949',
    contrastText: '#fff',
  },
  // MUI's light-theme defaults, so the shadcn Badge, Alert and Toast
  // variants that replaced Chip, Alert and Snackbar keep today's colours.
  // themeDefault.js does not read them: MUI supplies the same
  // values itself.
  success: {
    main: '#2e7d32',
    contrastText: '#fff',
  },
  warning: {
    main: '#ed6c02',
    contrastText: '#fff',
  },
  info: {
    main: '#0288d1',
    contrastText: '#fff',
  },
  grey: {
    50: '#ffffff', // used
    100: '#f7f7f7', // used
    200: '#f2f2f2', // used
    300: '#ddd', // used
    400: '#E4E4E4', // used
    500: '#aaaaaa', // used
    600: '#777777', // used
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161',
  },
}

export const radius = {
  // MUI buttons, selects and outlined inputs.
  control: '3px',
  // MUI menus and popovers (`menuCommonStyle`).
  menu: '10px',
  // MUI menu items.
  menuItem: '5px',
}

export const baseZIndex = 1000

/**
 * The legacy overlays' z-index: `.standard-modal` and `.fixed-modal`
 * (`_modals.scss`) and `.drawer-wrapper` (`_drawer.scss`) all sit at 100000,
 * and the Select menus inside legacy modals are hand-set to 100000 / 100001
 * to match. Everything shadcn that must open above a legacy modal starts
 * from here: `tailwind.config.js` derives its `dialog`, `toast` and
 * `popover` z-index tokens from this one value. SweetAlert sits at 300000
 * and stays above.
 */
export const legacyOverlayZIndex = 100000

export const getThemeZIndex = ({ baseZIndex: base = baseZIndex } = {}) => {
  return {
    mobileStepper: base,
    speedDial: base + 50,
    appBar: base + 100,
    drawer: base + 200,
    modal: base + 300,
    snackbar: base + 400,
    tooltip: base + 500,
  }
}
